import prettyBytes from 'pretty-bytes'

const quotas = [
    0, // unlimited
    10000000, // 10 MB
    20000000,
    30000000,
    40000000,
    50000000,
    60000000,
    70000000,
    80000000,
    90000000,
    100000000, // 100 MB
    200000000,
    300000000,
    400000000,
    500000000,
    600000000,
    700000000,
    800000000,
    900000000,
    1000000000, // 1 GB
    2000000000,
    3000000000,
    4000000000,
    5000000000,
    6000000000,
    7000000000,
    8000000000,
    9000000000,
    10000000000, // 10 GB
]

export default quotas.map(quota => {
    return {
        value: quota,
        label: quota === 0 ? 'Unlimited' : prettyBytes(quota),
    }
})